$(document).ready(function() {
$('.herotext_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    loop:false,
    autoplay:true,
  vertical: true,
    fade: false
});

    });
